import type { ReactNode } from 'react'

import '@hotmart/cosmos/dist/alert'

import '@hotmart/cosmos/dist/alert/variations/info.css'
import '@hotmart/cosmos/dist/alert/variations/success.css'
import '@hotmart/cosmos/dist/alert/variations/danger.css'
import '@hotmart/cosmos/dist/alert/variations/warning.css'
import clsx from 'clsx'

export type Variation = 'info' | 'success' | 'warning' | 'danger' | 'default'

type AlertProps = {
  children: ReactNode
  className?: string
  variation?: Variation
  dismissible?: boolean
}

const Alert = ({ children, className, variation = 'default', dismissible = false }: AlertProps) => {
  const alertClass = clsx(
    {
      [`hot-alert--${variation}`]: variation !== 'default'
    },
    className
  )

  return (
    <hot-alert
      data-test='membership-alert'
      role='alert'
      class={alertClass}
      {...(dismissible ? { dismissible } : '')}>
      {children}
    </hot-alert>
  )
}

export default Alert
